<div class="request-credits-content">
  <div class="request-credits-form-wrapper">
    <form [formGroup]="requestCreditsForm" class="request-credits-form" (ngSubmit)="!readOnly && !hasPendingRequest && requestCredits()">
      <!-- Accordion Sections -->
      <div class="request-credits-accordion">
        <!-- Applicant Information Section -->
        <div class="accordion-item" [class.expanded]="isSectionExpanded('applicant-info')">
          <button 
            type="button"
            class="accordion-header"
            (click)="toggleAccordionSection('applicant-info')"
          >
            <span class="accordion-title">Applicant Information</span>
            <div class="accordion-icons">
              <svg 
                class="accordion-chevron"
                [class.expanded]="isSectionExpanded('applicant-info')"
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"
              >
                <path d="M9 18l6-6-6-6"/>
              </svg>
              <div class="accordion-checkmark-wrapper">
                <svg 
                  class="accordion-checkmark"
                  [class.state-none]="getSectionCompletionState('applicant-info') === 'partial'"
                  [class.state-partial]="getSectionCompletionState('applicant-info') === 'none'"
                  [class.state-complete]="getSectionCompletionState('applicant-info') === 'complete'"
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  stroke-width="2" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"
                >
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9 12l2 2 4-4"/>
                </svg>
                <div class="accordion-tooltip" *ngIf="getSectionCompletionState('applicant-info') !== 'complete'">
                  {{ getSectionTooltip('applicant-info') }}
                </div>
              </div>
            </div>
          </button>
          <div class="accordion-content" *ngIf="isSectionExpanded('applicant-info')">
            <div class="form-field">
              <label for="applicantName" class="form-label">Applicant Name</label>
              <input 
                type="text" 
                id="applicantName" 
                formControlName="applicantName"
                class="form-input"
                placeholder="Applicant Name"
              />
              <div 
                *ngIf="requestCreditsForm.get('applicantName')?.invalid && requestCreditsForm.get('applicantName')?.touched"
                class="error-message"
              >
                Applicant name is required
              </div>
            </div>
            
            <div class="form-field">
              <label class="form-label form-label-inline">
                <span>Are you a member of an organization registered on MahaAgX? <span class="required-asterisk">*</span></span>
                <div class="switch-container-inline">
                  <label class="switch-label">
                    <span class="switch-label-text">{{ requestCreditsForm.get('isOrganizationMember')?.value === true ? 'Yes' : 'No' }}</span>
                    <div class="switch-wrapper">
                      <input 
                        type="checkbox" 
                        formControlName="isOrganizationMember"
                        class="switch-input"
                        [checked]="requestCreditsForm.get('isOrganizationMember')?.value === true"
                      />
                      <span class="switch-slider"></span>
                    </div>
                  </label>
                </div>
              </label>
              <div 
                *ngIf="requestCreditsForm.get('isOrganizationMember')?.invalid && requestCreditsForm.get('isOrganizationMember')?.touched"
                class="error-message"
              >
                This field is required
              </div>
            </div>

            <!-- Personal Fields (shown when switch is OFF/No) -->
            <div *ngIf="requestCreditsForm.get('isOrganizationMember')?.value === false" class="personal-fields-grid">
              <div class="form-field col-6">
                <label for="emailId" class="form-label">
                  Your Email ID <span class="required-asterisk">*</span>
                </label>
                <input 
                  type="email" 
                  id="emailId" 
                  formControlName="emailId"
                  class="form-input"
                  placeholder="Enter Email ID"
                />
                <div 
                  *ngIf="requestCreditsForm.get('emailId')?.invalid && requestCreditsForm.get('emailId')?.touched"
                  class="error-message"
                >
                  Valid email ID is required
                </div>
              </div>

              <div class="form-field col-6">
                <label for="location" class="form-label">
                  Your Location <span class="required-asterisk">*</span>
                </label>
                <input 
                  type="text" 
                  id="location" 
                  formControlName="location"
                  class="form-input"
                  placeholder="City, State"
                />
                <div 
                  *ngIf="requestCreditsForm.get('location')?.invalid && requestCreditsForm.get('location')?.touched"
                  class="error-message"
                >
                  Location is required
                </div>
              </div>
            </div>

            <!-- Organization Fields (shown when switch is ON/Yes) -->
            <div *ngIf="requestCreditsForm.get('isOrganizationMember')?.value === true" class="organization-fields-grid">
              <!-- Warning message when user has no organisation -->
              <div *ngIf="hasNoOrganisation" class="warning-message col-12">
                You're not part of an organisation. Please select No Option to proceed
              </div>
              <div class="form-field col-6">
                <label for="organisationName" class="form-label">Organisation Name</label>
                <input 
                  type="text" 
                  id="organisationName" 
                  formControlName="organisationName"
                  class="form-input"
                  placeholder="Enter Organisation Name"
                />
                <div 
                  *ngIf="requestCreditsForm.get('organisationName')?.invalid && requestCreditsForm.get('organisationName')?.touched"
                  class="error-message"
                >
                  Organisation name is required
                </div>
              </div>

              <div class="form-field col-6">
                <label for="organisationType" class="form-label">Organisation Type</label>
                <input 
                  type="text" 
                  id="organisationType" 
                  formControlName="organisationType"
                  class="form-input"
                  placeholder="Enter Organisation Type"
                />
                <div 
                  *ngIf="requestCreditsForm.get('organisationType')?.invalid && requestCreditsForm.get('organisationType')?.touched"
                  class="error-message"
                >
                  Organisation type is required
                </div>
              </div>

              <div class="form-field col-6">
                <label for="organisationLocation" class="form-label">Organisation Location</label>
                <input 
                  type="text" 
                  id="organisationLocation" 
                  formControlName="organisationLocation"
                  class="form-input"
                  placeholder="City, State"
                />
                <div 
                  *ngIf="requestCreditsForm.get('organisationLocation')?.invalid && requestCreditsForm.get('organisationLocation')?.touched"
                  class="error-message"
                >
                  Organisation location is required
                </div>
              </div>

              <div class="form-field col-6">
                <label for="organisationWebsiteUrl" class="form-label">Organisation Website URL</label>
                <input 
                  type="url" 
                  id="organisationWebsiteUrl" 
                  formControlName="organisationWebsiteUrl"
                  class="form-input"
                  placeholder="https://example.com"
                />
                <div 
                  *ngIf="requestCreditsForm.get('organisationWebsiteUrl')?.invalid && requestCreditsForm.get('organisationWebsiteUrl')?.touched"
                  class="error-message"
                >
                  Valid website URL is required
                </div>
              </div>

              <div class="form-field col-6">
                <label for="jobTitle" class="form-label">Your Job Title</label>
                <input 
                  type="text" 
                  id="jobTitle" 
                  formControlName="jobTitle"
                  class="form-input"
                  placeholder="Enter Job Title"
                />
                <div 
                  *ngIf="requestCreditsForm.get('jobTitle')?.invalid && requestCreditsForm.get('jobTitle')?.touched"
                  class="error-message"
                >
                  Job title is required
                </div>
              </div>

              <div class="form-field col-6">
                <label for="businessEmail" class="form-label">Your Email ID (business email)</label>
                <input 
                  type="email" 
                  id="businessEmail" 
                  formControlName="businessEmail"
                  class="form-input"
                  placeholder="Enter Business Email"
                />
                <div 
                  *ngIf="requestCreditsForm.get('businessEmail')?.invalid && requestCreditsForm.get('businessEmail')?.touched"
                  class="error-message"
                >
                  Valid business email is required
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Project Overview Section -->
        <div class="accordion-item" [class.expanded]="isSectionExpanded('project-overview')">
          <button 
            type="button"
            class="accordion-header"
            (click)="toggleAccordionSection('project-overview')"
          >
            <span class="accordion-title">Project Overview</span>
            <div class="accordion-icons">
              <svg 
                class="accordion-chevron"
                [class.expanded]="isSectionExpanded('project-overview')"
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"
              >
                <path d="M9 18l6-6-6-6"/>
              </svg>
              <div class="accordion-checkmark-wrapper">
                <svg 
                  class="accordion-checkmark"
                  [class.state-none]="getSectionCompletionState('project-overview') === 'partial'"
                  [class.state-partial]="getSectionCompletionState('project-overview') === 'none'"
                  [class.state-complete]="getSectionCompletionState('project-overview') === 'complete'"
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  stroke-width="2" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"
                >
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9 12l2 2 4-4"/>
                </svg>
                <div class="accordion-tooltip" *ngIf="getSectionCompletionState('project-overview') !== 'complete'">
                  {{ getSectionTooltip('project-overview') }}
                </div>
              </div>
            </div>
          </button>
          <div class="accordion-content" *ngIf="isSectionExpanded('project-overview')">
            <div class="form-field">
              <label for="projectTitle" class="form-label">
                Project Title <span class="required-asterisk">*</span>
              </label>
              <input 
                type="text" 
                id="projectTitle" 
                formControlName="projectTitle"
                class="form-input"
                placeholder="Enter Project Title"
              />
              <div 
                *ngIf="requestCreditsForm.get('projectTitle')?.invalid && requestCreditsForm.get('projectTitle')?.touched"
                class="error-message"
              >
                Project title is required
              </div>
            </div>
            
            <div class="description-fields-grid">
              <div class="form-field col-6">
                <label for="projectDescription" class="form-label">
                  Brief Description of the AI Project / Model <span class="required-asterisk">*</span>
                </label>
                <div class="textarea-wrapper">
                  <textarea 
                    id="projectDescription" 
                    formControlName="projectDescription"
                    class="form-textarea"
                    rows="5"
                    placeholder="Describe your AI project or model"
                    maxlength="250"
                  ></textarea>
                  <small class="char-counter">
                    <span class="text-danger">{{ projectDescriptionLength }}/250 characters</span>
                  </small>
                </div>
                <div 
                  *ngIf="requestCreditsForm.get('projectDescription')?.invalid && requestCreditsForm.get('projectDescription')?.touched"
                  class="error-message"
                >
                  Brief description is required
                </div>
              </div>
              
              <div class="form-field col-6">
                <label for="problemStatement" class="form-label">
                  What problem are you solving, and how is it innovative? <span class="required-asterisk">*</span>
                </label>
                <textarea 
                  id="problemStatement" 
                  formControlName="problemStatement"
                  class="form-textarea"
                  rows="5"
                  placeholder="Describe the problem and your innovative solution"
                ></textarea>
                <div 
                  *ngIf="requestCreditsForm.get('problemStatement')?.invalid && requestCreditsForm.get('problemStatement')?.touched"
                  class="error-message"
                >
                  Problem statement is required
                </div>
              </div>
            </div>
            
            <div class="select-fields-grid">
              <div class="form-field col-6">
                <label for="projectSector" class="form-label">
                  Which sector does your use case align with? <span class="required-asterisk">*</span>
                </label>
                <app-single-select
                  id="projectSector"
                  formControlName="projectSector"
                  [options]="projectSectorOptions"
                  optionLabel="label"
                  placeholder="Select sector"
                ></app-single-select>
                <div 
                  *ngIf="requestCreditsForm.get('projectSector')?.invalid && requestCreditsForm.get('projectSector')?.touched"
                  class="error-message"
                >
                  Sector selection is required
                </div>
              </div>
              
              <div class="form-field col-6">
                <label for="endUsers" class="form-label">
                  Who are your end users or beneficiaries? <span class="required-asterisk">*</span>
                </label>
                <app-single-select
                  id="endUsers"
                  formControlName="endUsers"
                  [options]="endUsersOptions"
                  optionLabel="label"
                  placeholder="Select end users/beneficiaries"
                ></app-single-select>
                <div 
                  *ngIf="requestCreditsForm.get('endUsers')?.invalid && requestCreditsForm.get('endUsers')?.touched"
                  class="error-message"
                >
                  End users selection is required
                </div>
              </div>
            </div>
            
            <div class="dataset-stage-fields-grid">
              <div class="form-field col-6">
                <label for="tgdexDataset" class="form-label">
                  What is the dataset on MahaAgX that is being used for the model development? <span class="required-asterisk">*</span>
                </label>
                <input 
                  type="text" 
                  id="tgdexDataset" 
                  formControlName="tgdexDataset"
                  class="form-input"
                  placeholder="Enter MahaAgX dataset name"
                />
                <div 
                  *ngIf="requestCreditsForm.get('tgdexDataset')?.invalid && requestCreditsForm.get('tgdexDataset')?.touched"
                  class="error-message"
                >
                  MahaAgX dataset name is required
                </div>
              </div>
              
              <div class="form-field col-6">
                <label for="projectStage" class="form-label">
                  Current Stage of Project? <span class="required-asterisk">*</span>
                </label>
                <app-single-select
                  id="projectStage"
                  formControlName="projectStage"
                  [options]="projectStageOptions"
                  optionLabel="label"
                  placeholder="Select current stage"
                ></app-single-select>
                <div 
                  *ngIf="requestCreditsForm.get('projectStage')?.invalid && requestCreditsForm.get('projectStage')?.touched"
                  class="error-message"
                >
                  Project stage selection is required
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Technical Information for GPU Requirements Section -->
        <div class="accordion-item" [class.expanded]="isSectionExpanded('technical-info')">
          <button 
            type="button"
            class="accordion-header"
            (click)="toggleAccordionSection('technical-info')"
          >
            <span class="accordion-title">Technical Information for GPU Requirements</span>
            <div class="accordion-icons">
              <svg 
                class="accordion-chevron"
                [class.expanded]="isSectionExpanded('technical-info')"
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"
              >
                <path d="M9 18l6-6-6-6"/>
              </svg>
              <div class="accordion-checkmark-wrapper">
                <svg 
                  class="accordion-checkmark"
                  [class.state-none]="getSectionCompletionState('technical-info') === 'partial'"
                  [class.state-partial]="getSectionCompletionState('technical-info') === 'none'"
                  [class.state-complete]="getSectionCompletionState('technical-info') === 'complete'"
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  stroke-width="2" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"
                >
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9 12l2 2 4-4"/>
                </svg>
                <div class="accordion-tooltip" *ngIf="getSectionCompletionState('technical-info') !== 'complete'">
                  {{ getSectionTooltip('technical-info') }}
                </div>
              </div>
            </div>
          </button>
          <div class="accordion-content" *ngIf="isSectionExpanded('technical-info')">
            <div class="select-fields-grid">
              <div class="form-field col-6">
                <label for="modelType" class="form-label">
                  Type of AI/ML model you're training <span class="required-asterisk">*</span>
                </label>
                <app-single-select
                  id="modelType"
                  formControlName="modelType"
                  [options]="modelTypeOptions"
                  optionLabel="label"
                  placeholder="Select model type"
                ></app-single-select>
                <div 
                  *ngIf="requestCreditsForm.get('modelType')?.invalid && requestCreditsForm.get('modelType')?.touched"
                  class="error-message"
                >
                  Model type is required
                </div>
              </div>

              <div class="form-field col-6">
                <label for="inputDataType" class="form-label">
                  Input Data Type <span class="required-asterisk">*</span>
                </label>
                <app-single-select
                  id="inputDataType"
                  formControlName="inputDataType"
                  [options]="inputDataTypeOptions"
                  optionLabel="label"
                  placeholder="Select input data type"
                ></app-single-select>
                <div 
                  *ngIf="requestCreditsForm.get('inputDataType')?.invalid && requestCreditsForm.get('inputDataType')?.touched"
                  class="error-message"
                >
                  Input data type is required
                </div>
              </div>
            </div>

            <div class="select-fields-grid">
              <div class="form-field col-6">
                <label class="form-label">
                  Is this model pre-trained or being trained from scratch? <span class="required-asterisk">*</span>
                </label>
                <div class="radio-options">
                  <div
                    *ngFor="let option of trainingTypeOptions"
                    class="radio-option"
                    [class.selected]="requestCreditsForm.get('trainingType')?.value === option.value"
                    (click)="selectTrainingType(option.value)"
                  >
                    <div class="radio-option-content">
                      <div class="radio-option-radio">
                        <div class="radio-circle" [class.checked]="requestCreditsForm.get('trainingType')?.value === option.value">
                          <svg *ngIf="requestCreditsForm.get('trainingType')?.value === option.value" width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="5" fill="currentColor"/>
                          </svg>
                        </div>
                      </div>
                      <div class="radio-label">{{ option.label }}</div>
                    </div>
                    <input 
                      type="radio" 
                      [value]="option.value"
                      formControlName="trainingType"
                      [checked]="requestCreditsForm.get('trainingType')?.value === option.value"
                      style="display: none;"
                    />
                  </div>
                </div>
                <div 
                  *ngIf="requestCreditsForm.get('trainingType')?.invalid && requestCreditsForm.get('trainingType')?.touched"
                  class="error-message"
                >
                  Training type is required
                </div>
              </div>

              <div class="form-field col-6">
                <label for="dataVolume" class="form-label">
                  Volume of Training Data (approx.) <span class="required-asterisk">*</span>
                </label>
                <app-single-select
                  id="dataVolume"
                  formControlName="dataVolume"
                  [options]="dataVolumeOptions"
                  optionLabel="label"
                  placeholder="Select data volume"
                ></app-single-select>
                <div 
                  *ngIf="requestCreditsForm.get('dataVolume')?.invalid && requestCreditsForm.get('dataVolume')?.touched"
                  class="error-message"
                >
                  Data volume is required
                </div>
              </div>
            </div>

            <div class="select-fields-grid">
              <div class="form-field col-6">
                <label for="trainingIterations" class="form-label">
                  Number of Training Iterations / Epochs Estimated
                </label>
                <input 
                  type="number" 
                  id="trainingIterations" 
                  formControlName="trainingIterations"
                  class="form-input"
                  placeholder="Enter estimated number of epochs"
                  min="0"
                />
              </div>

              <div class="form-field col-6">
                <label for="estimatedBatchSize" class="form-label">
                  Estimated Batch Size
                </label>
                <input 
                  type="number" 
                  id="estimatedBatchSize" 
                  formControlName="estimatedBatchSize"
                  class="form-input"
                  placeholder="Enter estimated batch size"
                  min="0"
                />
              </div>
            </div>

            <div class="select-fields-grid">
              <div class="form-field col-6">
                <label for="estimatedGpuHours" class="form-label">
                  Estimated Total GPU Hours Needed <span class="required-asterisk">*</span>
                </label>
                <input 
                  type="number" 
                  id="estimatedGpuHours" 
                  formControlName="estimatedGpuHours"
                  class="form-input"
                  placeholder="Enter estimated GPU hours"
                  min="0"
                  step="0.01"
                />
                <div 
                  *ngIf="requestCreditsForm.get('estimatedGpuHours')?.invalid && requestCreditsForm.get('estimatedGpuHours')?.touched"
                  class="error-message"
                >
                  Estimated GPU hours is required
                </div>
              </div>

              <div class="form-field col-6">
                <label class="form-label">
                  Have you used MahaAgX compute resources previously? <span class="required-asterisk">*</span>
                </label>
                <div class="radio-options">
                  <div
                    *ngFor="let option of tgdexUsageOptions"
                    class="radio-option"
                    [class.selected]="requestCreditsForm.get('tgdexUsagePreviously')?.value === option.value"
                    (click)="selectTgdexUsage(option.value)"
                  >
                    <div class="radio-option-content">
                      <div class="radio-option-radio">
                        <div class="radio-circle" [class.checked]="requestCreditsForm.get('tgdexUsagePreviously')?.value === option.value">
                          <svg *ngIf="requestCreditsForm.get('tgdexUsagePreviously')?.value === option.value" width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="5" fill="currentColor"/>
                          </svg>
                        </div>
                      </div>
                      <div class="radio-label">{{ option.label }}</div>
                    </div>
                    <input 
                      type="radio" 
                      [value]="option.value"
                      formControlName="tgdexUsagePreviously"
                      [checked]="requestCreditsForm.get('tgdexUsagePreviously')?.value === option.value"
                      style="display: none;"
                    />
                  </div>
                </div>
                <div 
                  *ngIf="requestCreditsForm.get('tgdexUsagePreviously')?.invalid && requestCreditsForm.get('tgdexUsagePreviously')?.touched"
                  class="error-message"
                >
                  This field is required
                </div>
              </div>
            </div>

            <div class="select-fields-grid">
              <div class="form-field col-6">
                <label for="preferredTimeslots" class="form-label">
                  Preferred timeslots for GPU usage
                </label>
                <textarea 
                  id="preferredTimeslots" 
                  formControlName="preferredTimeslots"
                  class="form-textarea"
                  rows="3"
                  placeholder="e.g., 50 GPU hours from 2:00 PM 02/06/2025 to 8:00 PM 02/06/2025"
                ></textarea>
              </div>

              <div class="form-field col-6">
                <label for="briefJustification" class="form-label">
                  Brief justification for compute request <span class="required-asterisk">*</span>
                </label>
                <div class="textarea-wrapper">
                  <textarea 
                    id="briefJustification" 
                    formControlName="briefJustification"
                    class="form-textarea"
                    rows="4"
                    placeholder="Explain why you need compute resources"
                    maxlength="150"
                  ></textarea>
                  <small class="char-counter">
                    <span class="text-danger">{{ briefJustificationLength }}/150 characters</span>
                  </small>
                </div>
                <div 
                  *ngIf="requestCreditsForm.get('briefJustification')?.invalid && requestCreditsForm.get('briefJustification')?.touched"
                  class="error-message"
                >
                  Brief justification is required
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Team Credentials Section -->
        <div class="accordion-item" [class.expanded]="isSectionExpanded('team-credentials')">
          <button 
            type="button"
            class="accordion-header"
            (click)="toggleAccordionSection('team-credentials')"
          >
            <span class="accordion-title">Team Credentials</span>
            <div class="accordion-icons">
              <svg 
                class="accordion-chevron"
                [class.expanded]="isSectionExpanded('team-credentials')"
                width="16" 
                height="16" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="currentColor" 
                stroke-width="2" 
                stroke-linecap="round" 
                stroke-linejoin="round"
              >
                <path d="M9 18l6-6-6-6"/>
              </svg>
              <div class="accordion-checkmark-wrapper">
                <svg 
                  class="accordion-checkmark"
                  [class.state-none]="getSectionCompletionState('team-credentials') === 'partial'"
                  [class.state-partial]="getSectionCompletionState('team-credentials') === 'none'"
                  [class.state-complete]="getSectionCompletionState('team-credentials') === 'complete'"
                  width="20" 
                  height="20" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  stroke-width="2" 
                  stroke-linecap="round" 
                  stroke-linejoin="round"
                >
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9 12l2 2 4-4"/>
                </svg>
                <div class="accordion-tooltip" *ngIf="getSectionCompletionState('team-credentials') !== 'complete'">
                  {{ getSectionTooltip('team-credentials') }}
                </div>
              </div>
            </div>
          </button>
          <div class="accordion-content" *ngIf="isSectionExpanded('team-credentials')">
            <div class="select-fields-grid">
              <div class="form-field col-6">
                <label for="teamSize" class="form-label">
                  Team Size <span class="required-asterisk">*</span>
                </label>
                <app-single-select
                  id="teamSize"
                  formControlName="teamSize"
                  [options]="teamSizeOptions"
                  optionLabel="label"
                  placeholder="Select team size"
                ></app-single-select>
                <div 
                  *ngIf="requestCreditsForm.get('teamSize')?.invalid && requestCreditsForm.get('teamSize')?.touched"
                  class="error-message"
                >
                  Team size is required
                </div>
              </div>

              <div class="form-field col-6">
                <label for="latestValuation" class="form-label">
                  What is your latest valuation?
                </label>
                <input 
                  type="text" 
                  id="latestValuation" 
                  formControlName="latestValuation"
                  class="form-input"
                  placeholder="Enter valuation amount"
                />
              </div>
            </div>

            <div class="description-fields-grid">
              <div class="form-field col-6">
                <label for="keyMembersRoles" class="form-label">
                  Key Members & Roles
                </label>
                <textarea 
                  id="keyMembersRoles" 
                  formControlName="keyMembersRoles"
                  class="form-textarea"
                  rows="5"
                  placeholder="List key team members and their roles in the project&#10;Format: Name - Role - Brief expertise"
                ></textarea>
              </div>

              <div class="form-field col-6">
                <label for="pastAiMlExperience" class="form-label">
                  Past AI/ML Experience
                </label>
                <textarea 
                  id="pastAiMlExperience" 
                  formControlName="pastAiMlExperience"
                  class="form-textarea"
                  rows="5"
                  placeholder="Describe team's relevant experience with AI/ML projects"
                ></textarea>
              </div>
            </div>

            <div class="description-fields-grid">
              <div class="form-field col-6">
                <label for="projectsPublications" class="form-label">
                  Projects / Publications / Competitions / Awards (Upload resume or links)
                </label>
                <textarea 
                  id="projectsPublications" 
                  formControlName="projectsPublications"
                  class="form-textarea"
                  rows="5"
                  placeholder="List or provide links to notable projects, publications, competitions, or awards"
                ></textarea>
              </div>

              <div class="form-field col-6">
                <label for="resumeFile" class="form-label">
                  Upload resume or portfolio (PDF/ Images [jpg, png, gif, webp, tiff, svg+xml, bmp])
                </label>
                <div class="file-upload-wrapper" [class.disabled]="readOnly">
                  <input
                    type="file"
                    id="resumeFile"
                    accept=".pdf,.doc,.docx"
                    (change)="onResumeFileSelected($event)"
                    class="file-input"
                    [disabled]="readOnly"
                  />
                  <label for="resumeFile" class="file-upload-label" *ngIf="!resumeFileName && !requestCreditsForm.get('resumeFile')?.value" [class.disabled]="readOnly">
                    <svg class="upload-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4M17 8l-5-5-5 5M12 3v12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <span class="upload-text">No file chosen</span>
                    <span class="upload-hint">Max file size: 5MB</span>
                  </label>
                  <div class="file-selected" *ngIf="resumeFileName || requestCreditsForm.get('resumeFile')?.value" [class.disabled]="readOnly">
                    <span class="file-name">{{ resumeFileName || 'Resume File' }}</span>
                    <div class="file-actions">
                      <button 
                        type="button" 
                        class="file-pdf-icon" 
                        *ngIf="(resumeFileName && resumeFileName.toLowerCase().endsWith('.pdf')) || (requestCreditsForm.get('resumeFile')?.value && requestCreditsForm.get('resumeFile')?.value.toLowerCase().includes('.pdf'))"
                        (click)="openPdfPreview(); $event.stopPropagation()"
                        title="Preview PDF"
                      >
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                          <polyline points="14 2 14 8 20 8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                      <button type="button" class="file-remove" (click)="removeResumeFile()" title="Remove file" *ngIf="!readOnly">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path d="M18 6L6 18M6 6l12 12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="error-message" *ngIf="selectedResumeFile && selectedResumeFile.size > 5 * 1024 * 1024">
                  File size exceeds 5MB limit
                </div>
                <div *ngIf="pdfLoading" class="file-upload-loading">
                  Uploading file...
                </div>
              </div>
            </div>

            <div class="select-fields-grid">
              <div class="form-field col-6">
                <label class="form-label">
                  Do you have any government, incubator, or VC support? <span class="required-asterisk">*</span>
                </label>
                <div class="radio-options">
                  <div
                    *ngFor="let option of supportOptions"
                    class="radio-option"
                    [class.selected]="requestCreditsForm.get('hasSupport')?.value === option.value"
                    (click)="selectSupportOption(option.value)"
                  >
                    <div class="radio-option-content">
                      <div class="radio-option-radio">
                        <div class="radio-circle" [class.checked]="requestCreditsForm.get('hasSupport')?.value === option.value">
                          <svg *ngIf="requestCreditsForm.get('hasSupport')?.value === option.value" width="10" height="10" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="12" cy="12" r="5" fill="currentColor"/>
                          </svg>
                        </div>
                      </div>
                      <div class="radio-label">{{ option.label }}</div>
                    </div>
                    <input 
                      type="radio" 
                      [value]="option.value"
                      formControlName="hasSupport"
                      [checked]="requestCreditsForm.get('hasSupport')?.value === option.value"
                      style="display: none;"
                    />
                  </div>
                </div>
                <div 
                  *ngIf="requestCreditsForm.get('hasSupport')?.invalid && requestCreditsForm.get('hasSupport')?.touched"
                  class="error-message"
                >
                  This field is required
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Checkboxes (hide in view-only modal) -->
      <div class="request-credits-checkboxes" *ngIf="!readOnly">
        <label class="checkbox-option">
          <input 
            type="checkbox" 
            class="checkbox-checkmark-custom"
            formControlName="confirmAccuracy"
          />
          <span>I confirm that the information provided above is accurate and complete.</span>
        </label>
        <div 
          *ngIf="requestCreditsForm.get('confirmAccuracy')?.invalid && requestCreditsForm.get('confirmAccuracy')?.touched"
          class="error-message"
        >
          This confirmation is required
        </div>

        <label class="checkbox-option">
          <input 
            type="checkbox" 
            class="checkbox-checkmark-custom"
            formControlName="understandGpuAllocation"
          />
          <span>I understand that GPU allocation will be limited and granted based on evaluation criteria.</span>
        </label>
        <div 
          *ngIf="requestCreditsForm.get('understandGpuAllocation')?.invalid && requestCreditsForm.get('understandGpuAllocation')?.touched"
          class="error-message"
        >
          This confirmation is required
        </div>
      </div>

      <!-- Submit Button (hidden in view-only modal) -->
      <div class="form-actions" *ngIf="!readOnly">
        <button 
          type="submit" 
          class="btn-submit"
          [disabled]="hasPendingRequest || requestCreditsForm.invalid || !areAllSectionsComplete()"
        >
          Submit
        </button>
      </div>
    </form>
  </div>
</div>

<!-- PDF Preview Modal -->
<app-modal
  [(visible)]="showPdfPreviewModal"
  header="Preview"
  [width]="'90vw'"
  [modal]="true"
  [closable]="true"
  [showFooter]="false"
  (onClose)="closePdfPreview()"
>
  <div class="pdf-preview-container" *ngIf="showPdfPreviewModal">
    <!-- Loading state -->
    <div *ngIf="pdfLoading" class="pdf-loading">
      <div class="loading-spinner"></div>
      <p>Loading PDF...</p>
    </div>
    
    <!-- PDF Viewer -->
    <pdf-viewer
      *ngIf="!pdfLoading && currentPdfUrl"
      [src]="currentPdfUrl"
      [render-text]="true"
      [original-size]="false"
      [show-all]="false"
      [zoom]="1"
      [zoom-scale]="'page-width'"
      [stick-to-page]="true"
      style="width: 100%; height: 100%;"
    ></pdf-viewer>
  </div>
</app-modal>
